const https = 'https://'

const urlRegex = /(http(s?)):\/\//i

export const isHttpsOrHttpPresented = (url?: string) =>
  url && url?.match(urlRegex)

export const normalizedUrl = (url: string) =>
  isHttpsOrHttpPresented(url) ? url : https + url
